import React from 'react';
import { Stack, Badge } from '@moda/om';
import { SizeInventoryFragment } from '../../generated/types';
import { SizeGuideLink, showSizeGuide } from '../SizeGuide';
import { SizeSelectorList } from './SizeSelectorList';
import './MobileSelectSizeView.scss';

type Props = {
  fitRecommendation?: string | null;
  sizes: SizeInventoryFragment[];
  sizeEquivalents: string[][];
  disableSizeMapping: boolean;
  selectedSize: SizeInventoryFragment | null;
  onSelect: (size: SizeInventoryFragment) => void;
};

export const MobileSelectSizeView: React.FC<Props> = ({
  fitRecommendation,
  sizes,
  sizeEquivalents,
  disableSizeMapping,
  selectedSize,
  onSelect
}) => (
  <Stack space={4}>
    {fitRecommendation && <Badge theme="noise">{fitRecommendation}</Badge>}
    <SizeSelectorList
      sizes={sizes}
      sizeEquivalents={sizeEquivalents}
      disableSizeMapping={disableSizeMapping}
      selectedSize={selectedSize}
      onSelect={onSelect}
    />
    {showSizeGuide({ sizeEquivalents, disableSizeMapping }) && (
      <div className="MobileSelectSizeView__footer">
        <SizeGuideLink
          sizes={sizes}
          sizeEquivalents={sizeEquivalents}
          disableSizeMapping={disableSizeMapping}
          fitRecommendation={fitRecommendation}
        />
      </div>
    )}
  </Stack>
);
